import Header from "components/PurchaserFrontend/Headers/Header.js";

const PurchaserIndex = (props) =>
{
	return (
		<>
			<Header token={props.token} id={props.purchaserId}/>
		</>
	);
};

export default PurchaserIndex;
